import create from './create.actions'
import view from './view.actions'

export default {
  create,
  view,
}
